import { depictMerchant } from "@/lib/depict-client/depict-merchant"
import { type IRecommendationsService } from "@/lib/depict-client/interfaces/IRecommendationsService"
import { type RecommendRequestV3 } from "@/lib/depict-client/types/api/RecommendRequestV3"
import { type RecommendResponseV3 } from "@/lib/depict-client/types/api/RecommendResponseV3"
import { type ClientFetchService } from "@/lib/http/ClientFetchService"
import { type FetchService } from "@/lib/http/FetchService"
import { type Result } from "@/types/generic/Result"

export class RecommendationsApiService implements IRecommendationsService {
    constructor(private fetchService: FetchService | ClientFetchService) {}

    /**
     * Returns a list of displays.
     * @param {RecommendRequestV3} req
     * @link https://docs.depict.ai/reference/openapi-reference/recommendations-v3/recommendations
     */
    public getProducts = async (
        req: RecommendRequestV3
    ): Promise<Result<RecommendResponseV3>> => {
        return this.fetchService.fetch("/recommend/products", {
            method: "POST",
            body: JSON.stringify({ ...req, merchant: depictMerchant })
        })
    }
}
